import { useState } from "react";
import I18n from "i18n-js";
import { useScale, btnDelay, usePlaySound } from "common/utils";
import { Footer, TitleSvg } from "features/home";
import { AuthSelection } from "features/auth/AuthSelection";
import { CreateGuestUser } from "features/auth/CreateGuestUser";

export const Onboarding = () => {
  const TITLE_WIDTH = 828;
  const TITLE_HEIGHT = 182;
  const ITEM_HEIGHT = 454;
  const ITEM_TOP_MARGIN = 28;
  const play = usePlaySound();
  const { scale } = useScale();
  const [guest, setGuest] = useState(false);
  const [signUp, setSignUp] = useState(false);

  const handleShowGuest = () => {
    btnDelay(() => {
      play();
      setGuest(true);
    });
  };
  const handleCloseGuest = () => {
    btnDelay(() => {
      play();
      setGuest(false);
    });
  };

  const handleShowAuthSelection = () => {
    btnDelay(() => {
      play();
      setSignUp(true);
    });
  };
  const handleCloseAuthSelection = () => {
    btnDelay(() => {
      play();
      setSignUp(false);
    });
  };

  return (
    <div className="flex-col-el flex-center relative w-full h-full">
      <CreateGuestUser open={guest} close={handleCloseGuest} />

      <AuthSelection open={signUp} close={handleCloseAuthSelection} />

      <div
        className="flex-col-view self-center"
        style={{
          width: TITLE_WIDTH * scale,
          height: TITLE_HEIGHT * scale,
        }}
      >
        <div
          className="flex-col-view origin-top-left"
          style={{
            width: TITLE_WIDTH,
            height: TITLE_HEIGHT,
            transform: `scale(${scale})`,
          }}
        >
          <TitleSvg />
        </div>
      </div>

      <div
        className="flex-col-center w-full"
        style={{
          height: ITEM_HEIGHT * scale,
          marginTop: ITEM_TOP_MARGIN * scale,
        }}
      >
        <div
          className="flex-row-center gap-8 upsilon"
          style={{ transform: `scale(${scale})` }}
        >
          <button
            className="btn btn-puzzle-blue"
            onClick={handleShowGuest}
            style={{
              width: "520px",
              height: "280px",
              borderRadius: "24px",
              boxShadow:
                "0 8px 24px rgba(76, 157, 241, 0.25), 0 4px 12px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div className="flex-col-center w-full h-full p-8 relative">
              <div className="flex-col-center mb-4">
                <div
                  className="flex-col-center bg-white rounded-[32px] w-[120px] h-[120px] shadow-lg border-4 border-blue-20"
                  style={{
                    boxShadow: "0 8px 16px rgba(76, 157, 241, 0.2)",
                  }}
                >
                  <span
                    className="material-symbols-outlined !text-[64px] text-blue-100"
                    aria-hidden="true"
                  >
                    rocket_launch
                  </span>
                </div>
              </div>

              <div className="text-center">
                <p className="text-body text-3xl text-white">
                  {I18n.t("MSG_ONBOARDING_FIRST_TIME")}
                </p>
                <p className="text-body text-base text-white !my-4">
                  {I18n.t("MSG_ONBOARDING_FIRST_TIME_SUB")}
                </p>
              </div>

              <div className="absolute top-4 right-4">
                <span className="material-symbols-outlined text-blue-40 text-2xl">
                  star
                </span>
              </div>
            </div>
          </button>

          <button
            className="btn btn-danger"
            onClick={handleShowAuthSelection}
            aria-label={I18n.t("MSG_ONBOARDING_EXISTING_USER")}
            style={{
              width: "520px",
              height: "280px",
              borderRadius: "24px",
              boxShadow:
                "0 8px 24px rgba(252, 101, 96, 0.25), 0 4px 12px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div className="flex-col-center w-full h-full p-8 relative">
              <div className="flex-col-center mb-4">
                <div
                  className="flex-col-center bg-white rounded-[32px] w-[120px] h-[120px] shadow-lg border-4 border-red-60"
                  style={{
                    boxShadow: "0 8px 16px rgba(252, 101, 96, 0.2)",
                  }}
                >
                  <span
                    className="material-symbols-outlined !text-[64px] text-red-100"
                    aria-hidden="true"
                  >
                    emoji_events
                  </span>
                </div>
              </div>

              <div className="text-center">
                <p className="text-body text-3xl text-white">
                  {I18n.t("MSG_ONBOARDING_EXISTING_USER")}
                </p>
                <p className="text-body text-base !my-4">
                  {I18n.t("MSG_ONBOARDING_EXISTING_USER_SUB")}
                </p>
              </div>

              <div className="absolute top-4 right-4">
                <span className="material-symbols-outlined text-red-40 text-2xl">
                  workspace_premium
                </span>
              </div>
            </div>
          </button>
        </div>
      </div>

      <Footer />
    </div>
  );
};
